import { render, staticRenderFns } from "./ActivityGaugeConfig.vue?vue&type=template&id=65021a06&scoped=true"
import script from "./ActivityGaugeConfig.vue?vue&type=script&lang=js"
export * from "./ActivityGaugeConfig.vue?vue&type=script&lang=js"
import style0 from "./ActivityGaugeConfig.vue?vue&type=style&index=0&id=65021a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65021a06",
  null
  
)

export default component.exports